import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Email } from '@alfa-bank/site-form-email';
import { FormInput } from '@alfa-bank/site-form-input';
import { Text } from '@alfa-bank/site-text-v2';
import { Button } from '@alfa-bank/site-button-v2';
import { Aligner } from '@alfa-bank/site-aligner';

import { InputPhone as Phone } from '../../components/input-phone';
import { CompanyFields } from '../../components/company-fields';
import { AgreementDesktop as Agreement } from '../../components/agreement/desktop';
import { SafeguardDesktop as Safeguard } from '../../components/safeguard/desktop/desktop';

import { FormLayout as Component } from './form-layout';
import type { TFormLayoutDesktop, IDepsDesktop } from './models';
import styles from './styles/styles.css';

// eslint-disable-next-line styler/check-styler
export const FormLayoutDesktop = createWidget<IDepsDesktop, TFormLayoutDesktop>({
    CompanyFields,
    Grid,
    Button,
    Safeguard,
    Aligner,
    Email,
    Phone,
    FormInput,
    Agreement,
    Text,
    styles,
    isMobile: false,
})(Component);
